import { useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Outlet, useLocation } from "react-router-dom";
import FirstAndLastMileDrawer from './FirstAndLastMileDrawer';
import FirstAndLastMileAppBar from './FirstAndLastMileAppBar';
import { Container, useMediaQuery } from '@mui/material';
import { useSocket } from 'src/_contexts/socket';
import { getCurrentUserProfile } from "src/_store/entities/profile";
import { useDispatch } from 'react-redux';
import CompleteProfileInfoAlert from 'src/_modules/Account/components/CompleteProfileInfoAlert';
import { containerSpacing } from 'src/_utils/containerSpacing';
import DrawerContext from 'src/_contexts/DrawerContext';
import { Alerts, GlobalConfirmDialog } from 'src/_modules/common';
import { PlanExpirationAlert } from 'src/_modules/Account/components';
import CreditsBalanceNotEnoughDialog from 'src/_modules/common/Dialogs/CreditsBalanceNotEnoughDialog';
import { HelpCenter } from 'src/components/common';

export default function ClippedDrawer() {
  const dispatch = useDispatch();
  const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));
  const [openDrawer, setOpenDrawer] = useState(false)

  const toggleDrawer = () => {
    setOpenDrawer((prevState) => !prevState)
  }
  
  const closeDrawer = () => {
    setOpenDrawer(false)
  }

  const drawerContextValue = {
    isOpen: openDrawer,
    toggle: toggleDrawer,
    close: closeDrawer
  };

  const { socket } = useSocket();

  const refetchProfileAccount = (data) => {
    if (["ACCOUNT_ACTIVATED"].includes(data.type)) {
      dispatch(getCurrentUserProfile())
    }
  }

  useEffect(_ => {
    if (socket) {
      socket.on("notification", refetchProfileAccount);
    }
    return _ => socket && socket.off('notification', refetchProfileAccount);
  }, [socket])

  //======= Spaceing =======
  const location = useLocation()
  const spacing = containerSpacing(location.pathname)

  return (
    <DrawerContext.Provider value={drawerContextValue}>
      <Box sx={{ display: downLg ? '' : 'flex' }}>
        <CssBaseline />
        <FirstAndLastMileAppBar toggleDrawer={toggleDrawer} />
        <FirstAndLastMileDrawer openDrawer={openDrawer} toggleDrawer={toggleDrawer} />
        {/* minWidth: 0 lets <main> shrink to the space beside the drawer; without it wide tables/tab rows
            push the page past the viewport, where html's overflow-x: hidden makes it unreachable */}
        <Box component="main" sx={{ flexGrow: 1, minWidth: 0, py: spacing ? 3 : undefined }}>
          <Toolbar />
          <CompleteProfileInfoAlert />
          <PlanExpirationAlert />
          <GlobalConfirmDialog />
          <CreditsBalanceNotEnoughDialog />
          <Alerts />
          <HelpCenter />
          <Container maxWidth={false} style={{ paddingLeft: spacing ? undefined : 0, paddingRight: spacing ? undefined : 0 }}>
            <Outlet />
          </Container>
        </Box>
      </Box>
    </DrawerContext.Provider>
  );
}